// extracted by mini-css-extract-plugin
module.exports = {"container":"organizationContent_container__2dj7a","list":"organizationContent_list__2IxFK","sidebar":"organizationContent_sidebar__1xxJL"};